var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-content d-flex align-center"},[_c('LoggedInHeader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }